module.exports = __webpack_public_path__ + "static/media/automatedcontent_decorative_section3.1b752d64.png";